/** Free trial: combined Generate + Export actions before paywall (not Stripe). */
export const TRIAL_USAGE_LIMIT = 20;
